import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { useEffect, useState } from "react"
import apis from "../../api"
import {  getUserSession,  } from "../../Utils/Common"
import { settingDataLoader } from "../../Component/DataLoader"


const TermSelector = (props) => {
    const { defaultValue,onChange,terms,name,label } = props
    const [_terms,setTerms] = useState(terms)
    const [error,setError] = useState()
    getUserSession(apis)
    useEffect(()=>{
        if(!_terms) {
            settingDataLoader('term',1,apis,(data)=>{setTerms(data)},setError)
        }
    },[])
    return <FormControl fullWidth sx={props.sx}>
        <InputLabel id="demo-simple-select-autowidth-label">{label} {error && <font style={{color:'red'}}>{error}</font>}</InputLabel>
        <Select labelId="demo-simple-select-autowidth-label"
            id={name}
            onChange={(e) => { 
                let id = e.target.value; 
                let choice = false
                if(id>0) {
                    for(let i=0;i<_terms.length;i++) {
                        if(id == _terms[i].id) {
                            onChange && onChange(name,_terms[i])
                            choice = true
                            break
                        }
                    }
                }
                if(!choice) {
                    onChange && onChange(name,{id:0})
                }
            }}
            defaultValue={defaultValue}
            label={label}>
            <MenuItem value={0}>Nothing</MenuItem>
            {_terms && _terms.map((p, idx) => {                       
                return p.status == 1 && <MenuItem key={idx} value={p.id}>{p.name}</MenuItem>
            })}
        </Select>
    </FormControl>
}
export default TermSelector